import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
let router = new Router({
  // export default new Router({
  routes: [
    {
      path: '/login',
      component: resolve => require(['../components/pages/login.vue'], resolve)
    },
    {
      path: '/register',
      component: resolve => require(['../components/pages/Register.vue'], resolve)
    },
    {
      path: '/',
      redirect: '/index'//登录页
    },
    {
      path: '/index',
      component: resolve => require(['../components/pages/newIndex.vue'], resolve)
    },
    {
      path: '/',
      component: resolve => require(['../components/common/index/home.vue'], resolve),
      children: [
        // {
        //   path: '/index',
        //   component: resolve => require(['../components/pages/index.vue'], resolve)
        // },
        {
          path: '/survey',
          component: resolve => require(['../components/pages/surveyPage.vue'], resolve)
        },
        {
          path: '/sampleServices',
          component: resolve => require(['../components/pages/SampleServices.vue'], resolve)
        },
        {
          path: '/wiseAdvice',
          component: resolve => require(['../components/pages/WiseAdvice.vue'], resolve)
        },
        {
          path: "/news",
          component: resolve => require(['../components/pages/news.vue'], resolve)
        },
        {
          path: "/newsDetail",
          component: resolve => require(['../components/pages/newsDetail.vue'], resolve)
        }

      ]
    },
    {
      path: '/manage',
      component: resolve => require(['../components/common/manage/home.vue'], resolve),
      children: [
        {
          path: '',
          component: resolve => require(['../components/pages/JiShuDiaoYan/index.vue'], resolve)
        },
        {
          path: '/manage/subject',
          component: resolve => require(['../components/pages/JiShuDiaoYan/addSubjectList.vue'], resolve)
        },
        {
          path: '/manage/topicGroup',
          component: resolve => require(['../components/pages/JiShuDiaoYan/TopicGroup.vue'], resolve)
        },
        {
          path: '/manage/statistics',
          component: resolve => require(['../components/pages/JiShuDiaoYan/statistics.vue'], resolve)
        },
        {
          path: '/manage/summary',
          component: resolve => require(['../components/pages/JiShuDiaoYan/SummaryAnswer.vue'], resolve)
        },
        {
          path: '/manage/membershipSystem',
          component: resolve => require(['../components/pages/JiShuDiaoYan/MembershipSystem.vue'], resolve)
        },
        {
          path: '/manage/auditList',
          component: resolve => require(['../components/pages/JiShuDiaoYan/AuditList.vue'], resolve)
        },
        {
          path: '/manage/invoiceList',
          component: resolve => require(['../components/pages/JiShuDiaoYan/invoiceList.vue'], resolve)
        },
        {
          path: '/manage/newsList',
          component: resolve => require(['../components/pages/JiShuDiaoYan/newsList.vue'], resolve)
        },
        {
          path: '/manage/addNews',
          component: resolve => require(['../components/pages/JiShuDiaoYan/addNews.vue'], resolve)
        },
      ]
    }
  ]
})
// router.beforeEach((to, from, next) => {
//   if (to.query.href == 1) {
//     next();
//   } else {
//     if (to.path === '/login' ||to.path === '/index') { // 如果是登录页面的话，直接next()
//       next();
//     } else { // 否则 跳转到登录页面
//       if (getCookie('cloudToken')) {
//         next();
//       } else {
//         next({
//           path: '/index'
//         });
//       }

//     }
//   }

// })

export function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return (arr[2]);
  else
    return null;
}

//删除cookie
export function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
};
export default router



// WEBPACK FOOTER //
// ./src/router/index.js